import { render, staticRenderFns } from "./CategoryCardMain.vue?vue&type=template&id=667707d2&scoped=true"
import script from "./CategoryCardMain.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategoryCardMain.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CategoryCardMain.vue?vue&type=style&index=0&id=667707d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667707d2",
  null
  
)

export default component.exports